import { useCallback } from 'react';
import { Button, Icon, Text } from '@mercator-gcp/grout';
import { useNavigate } from 'react-router-dom';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import {
  trackImportCompanies,
  ImportCompaniesSuccessStates,
} from 'services/analytics/trackImportCompanies';
import {
  CompanyGroupsPageViewSections,
  CompanyGroupsPageViewSubSections,
} from 'utils/analytics/constants';
import { GROUP_TYPE } from 'utils/constants';
import { QUERY_PARAM } from 'utils/constants/QueryParameters';
import { APP_ROUTES, buildDashboardURLWithParams } from 'utils/navigation';

const containerStyle = {
  marginTop: 'padding_16',
  alignItems: 'center',
};

const titleStyle = {
  marginBottom: 'padding_8',
  justifyContent: 'center',
};

const descriptionStyle = {
  marginBottom: 'padding_24',
  justifyContent: 'center',
};

const orCopyStyle = {
  marginTop: 'padding_16',
  marginBottom: 'padding_16',
  justifyContent: 'center',
};

type Props = {
  groupId: number;
};

const NoCompaniesInGroupPlaceholder = ({ groupId }: Props) => {
  const navigate = useNavigate();

  const onCLickCTA = useCallback(() => {
    navigate(APP_ROUTES.COMPANY_SEARCH_PAGE);
  }, []);

  const onClickImportCompanies = useCallback(() => {
    trackImportCompanies({
      group_id: String(groupId),
      section_name: CompanyGroupsPageViewSections.COMPANY_GROUPS,
      sub_section_name: CompanyGroupsPageViewSubSections.IMPORT,
      click_text: 'Import Companies',
      success_state: ImportCompaniesSuccessStates.START,
    });

    const base = buildDashboardURLWithParams({
      groupId,
      groupType: GROUP_TYPE.COMPANY,
    });

    navigate(`${base}&${QUERY_PARAM.importCompanies}=companies`);
  }, [groupId, navigate]);

  return (
    <FlexColumn sx={containerStyle}>
      <Text.H3 sx={titleStyle}>You have not saved any companies yet</Text.H3>
      <Text sx={descriptionStyle}>
        Get ready for your next meeting by tracking your clients.
      </Text>
      <Button
        variant="primary"
        onClick={onCLickCTA}
        startAdornment={<Icon name={Icon.Name.Search} />}
      >
        Search a company
      </Button>
      <Text sx={orCopyStyle}>OR</Text>
      <Button
        variant="secondary"
        onClick={onClickImportCompanies}
        startAdornment={<Icon name={Icon.Name.AddToList} />}
      >
        Import Companies
      </Button>
    </FlexColumn>
  );
};

export default NoCompaniesInGroupPlaceholder;
